import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { API } from "../Services/Api";
import {
  api_url,
  aplicacao,
  app_base_url,
  enderecos_api,
  itbi_sql_server_url,
  login_api,
} from "../Utils/Urls";

interface IEntidadeContextData {
  entidade: IEntidade;
  codigoFebraban:number;
}

interface IEntidadeProviderProps {
  children: ReactNode;
}

const EntidadeContext = createContext({} as IEntidadeContextData);
export const token_storage = "@login-unico";
function EntidadeProvider({ children }: IEntidadeProviderProps) {
  const [entidade, setEntidade] = useState({} as IEntidade);

  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  const [codigoFebraban, setCodigoFebraban] = useState(0);

  async function getCodigoFebraban() {
    try {
      setLoading(true);
      const febraban = await axios.post(
        `${itbi_sql_server_url}/prefeitura/codigo-febraban`,
        {
          bancoNum: entidade.banco.indexOf("2-") != -1 ? 2 : 1,
          bancoNome: entidade.banco.replaceAll("2-", "").replaceAll("1-", ""),
        }
      );

      setCodigoFebraban(febraban.data.C_FEBRABAN);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (entidade.id) getCodigoFebraban();
  }, [entidade]);

  async function getEntidadePorNomeDoBanco() {
    try {
      setLoading(true);
      const d = window.location.href.split("/");
      const indexOf = d.indexOf(app_base_url.replace("/", "")) + 1;
      const entidade_carregada = await axios.get(
        `${enderecos_api}/cod/${d[indexOf]}`
      );

      if (entidade_carregada.data.length > 0) {
        entidade_carregada.data[0].logo =
          enderecos_api + "/uploads/" + entidade_carregada.data[0].logo;

        setEntidade(entidade_carregada.data[0]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getEntidadePorNomeDoBanco();
  }, [window.location.href]);

  return (
    <EntidadeContext.Provider
      value={{
        entidade,
        codigoFebraban
      }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </EntidadeContext.Provider>
  );
}

function useEntidade() {
  const context = useContext(EntidadeContext);

  return context;
}

export { EntidadeProvider, useEntidade };

interface IUsuario {
  usuario: {
    id: number;
    entidade_id: number;
    usuario: string;
    senha: string;
    email: string;
    inativo: null | string;
    nome: string;
    foto: null | string;
  };
  entidade: IEntidade;
  sistemas: [
    {
      id: number;
      titulo: string;
      url: string;
    }
  ];
}

interface IEntidade {
  id: number;
  titulo: string;
  banco: string;
  logo: string;
  apresentacao: string;
  portal: string;
  site: string;
  site2: string;
  pasta: string;
}
